export const parseVideoIds = function (videoId) {
  let ret
  try {
    let theIDs = videoId.split(' ').join('').split(',')
    ret = theIDs
  } catch (err) {
    ret = false
  }
  return ret
}

export const findQuestionById = (questions, questionId) => {
  return questions.find(item => item.id === questionId)
}

export const findAnswerById = (question, answerId) => {
  return question.answers.find(item => item.id === answerId)
}

export const updateTally = (tally, resultId) => {
  tally[resultId] = tally[resultId] ? tally[resultId] + 1 : 1
}

export const calculateTally = (quiz, tally, questionId, answerId) => {
  const question = findQuestionById(quiz.questions, questionId)
  const answer = findAnswerById(question, answerId)

  if (answer.resultIds) {
    answer.resultIds.forEach(resultId => updateTally(tally, resultId))
  } else if (answer.resultId) {
    updateTally(tally, answer.resultId)
  }

  const maxResultId = Object.keys(tally).reduce((maxId, id) => {
    return tally[id] > (tally[maxId] || 0) ? id : maxId
  }, null)

  return {
    resultId: maxResultId,
    tally,
  }
}

export const filterQuestions = (questions, questionAnswerSet) => {
  const userAttributes = {}

  questionAnswerSet.forEach(({ questionId, answerId }) => {
    const question = findQuestionById(questions, questionId)
    const answer = findAnswerById(question, answerId)

    if (answer.keyValuePairs) {
      Object.keys(answer.keyValuePairs).forEach(key => {
        userAttributes[key] =
          (userAttributes[key] || 0) + parseInt(answer.keyValuePairs[key])
      })
    }
  })

  return questions.filter(question => {
    if (question.keyValuePairs) {
      return Object.keys(question.keyValuePairs).every(key => {
        return (
          !userAttributes[key] ||
          userAttributes[key] <= question.keyValuePairs[key]
        )
      })
    }
    return true
  })
}
